import React from 'react';
import myImage from '../../images/myImage.jpg';

const AboutMe = () => {
    return (
        <section id="contact" className="mt-5 mb-3 px-5 row align-items-center">
            {/* <div className="text-center"> */}
            <div className="col-md-5 d-flex justify-content-center">
                <img className="img-fluid" src={myImage} style={{ width: '80%' }} alt="" />
            </div>
            <div className="col-md-7 px-3">
                <div id="contact" className="mt-5 mb-3 px-2">
                    <div className="">

                        <h3>Personal Info</h3>
                        <div className="d-flex flex-row bd-highlight mb-3 mt-3">
                            <div className="col-md-6">
                                <h5 className="fw-bold">Passion: <span className="text-secondary">Programmer</span></h5>
                                <h5 className="fw-bold">Website: <span className="text-secondary">faiyad-ahmed-sudipto.web.app</span></h5>
                                <h5 className="fw-bold">City: <span className="text-secondary">Nilphamari, Bangladesh</span></h5>
                                {/* <u>dd</u> */}
                            </div>
                            <div className="col-md-6">
                                <h5 className="fw-bold">Birthday: <span className="text-secondary">faiyadahmedsudipto@gmail.com</span></h5>
                                <h5 className="fw-bold">Email: <span className="text-secondary">faiyadahmedsudipto@gmail.com</span></h5>
                                <h5 className="fw-bold">Phone: <span className="text-secondary">+880 1752-082739</span></h5>
                            </div>
                        </div>
                        <div>
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>
                            <br />
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" style={{ width: '25%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div>
                            <br />
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" style={{ width: '50%' }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">50%</div></div>
                            <br />
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" style={{ width: '75%' }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">75%</div></div>
                            <br />
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">100%</div></div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AboutMe;